module.exports = __webpack_public_path__ + "static/media/documentation.1d40c09d.md";